import React, { Component } from "react"
import moment from 'moment'
import { PropTypes } from "prop-types"
import { bindActionCreators } from 'redux'
import { connect } from "react-redux"
import { reduxForm, propTypes, formValueSelector, change } from 'redux-form'
import { Row, Col, Table, Button, FormGroup, ControlLabel, FormControl, InputGroup } from "react-bootstrap"
import ContentWrapper from "../../layout/ContentWrapper"
import { fetchAvailableRankings, fetchSeasonRankings, fetchSeasonWeeks, runRankings, publishRankings, fetchLastRankingRun } from "../../../redux/actions/action_season"
import { warning, red, blue } from '../../../utils/constants'
import isEmpty from "../../../utils/isEmpty"
import WhatIf from './components/whatIf'

const formName = 'seasonrankings'

class Ranking extends Component {
  static propTypes = {
    ...propTypes
  }
  constructor(props) {
    super(props)

    this.state = {
      gender: 'M',
      disableReRunRanking: false,
      defaultWeeksSet: false,
      runningRanking: false,
      showWhatIf: false,
    }
    this.handleShowRankings = this.handleShowRankings.bind(this)
    this.handleReRunRankings = this.handleReRunRankings.bind(this)
    this.handleRunWhatIf = this.handleRunWhatIf.bind(this)
    this.generateSeasonOptions = this.generateSeasonOptions.bind(this)
    this.generateSeasonWeeksOptions = this.generateSeasonWeeksOptions.bind(this)
    this.handleSeasonChange = this.handleSeasonChange.bind(this)
    this.setDefaultSeasonWeeks = this.setDefaultSeasonWeeks.bind(this)
    this.handleGenderChange = this.handleGenderChange.bind(this)
    this.handleWeekChange = this.handleWeekChange.bind(this)
    this.resetSearchResults = this.resetSearchResults.bind(this)
    this.onHandleCancelWhatIf = this.onHandleCancelWhatIf.bind(this)
    this.handlePublishRankings = this.handlePublishRankings.bind(this)
  }

  // React lifecycles methods
  componentDidMount() {
    this.props.fetchAvailableRankings()
    this.props.fetchLastRankingRun()
  }
  componentWillUnmount() {
    const { rankings, dispatch } = this.props
    if ((rankings != null) && (rankings.length > 0)) {
      dispatch(change(formName, 'rankings', []))
    }
  }
  // End lifecycles methods

  // Section event handlers
  handleShowRankings() {
    const { seasonId, weekNumber } = this.props
    const { gender } = this.state
    this.props.fetchSeasonRankings(seasonId, weekNumber, gender)
  }
  handleReRunRankings() {
    const { dispatch, season } = this.props

    this.setState({ runningRanking: true })
    const seasonYear = parseInt(season - 1);

    const token = this.props.oidc.user.access_token;
    dispatch(runRankings(seasonYear, token))
  }

  handleRunWhatIf() {
    this.setState({ showWhatIf: true })
  }
  handleSeasonChange(evt) {
    const { dispatch, fetchSeasonWeeks } = this.props
    const seasonId = evt.target.value
    this.setState({ disableReRunRanking: (parseInt(seasonId) < 21) })
    dispatch(change(formName, 'seasonId', seasonId))
    this.resetSearchResults()
    fetchSeasonWeeks(seasonId)
  }
  handleGenderChange(evt) {
    const gender = evt.target.value
    this.setState({ gender })
    this.resetSearchResults()
  }
  handleWeekChange(evt) {
    const { dispatch } = this.props
    const weekNumber = evt.target.value
    dispatch(change(formName, 'weekNumber', weekNumber))
    this.resetSearchResults()
  }
  onHandleCancelWhatIf() {
    this.setState({ showWhatIf: false })
  }

  handlePublishRankings() {
    const { seasonId } = this.props
    this.props.publishRankings(seasonId)
  }

  // End event handlers

  // Section supporting functions
  generateSeasonOptions() {
    const { availablerankings } = this.props
    const option = availablerankings.map((seasonyear) => {
      return (<option value={seasonyear.seasonId} key={seasonyear.seasonId}>{seasonyear.seasonYear + 1}</option>)
    })
    return option
  }
  generateSeasonWeeksOptions() {
    const { seasonweeks } = this.props
    const option = seasonweeks.map((week) => {
      return (<option value={week.weekNumber} key={week.weekNumber}>{moment(week.startDate).format('LL')}{' - '}{moment(week.endDate).format('LL')}</option>)
    })
    return option
  }
  setDefaultSeasonWeeks() {
    const { fetchSeasonWeeks, seasonId } = this.props
    const { defaultWeeksSet } = this.state

    // console.log('setDefaultSeasonWeeks defaultWeeksSet',seasonId,defaultWeeksSet)

    if ((defaultWeeksSet === false) && (seasonId > 0)) {
      fetchSeasonWeeks(seasonId)
      this.setState({ defaultWeeksSet: true })
      //fetchSeasonWeeks(seasonId)        
    }
  }
  resetSearchResults() {
    const { dispatch } = this.props
    dispatch(change(formName, 'rankings', []))
  }

  // End supporting functions

  render() {

    const {
      runningRanking,
      showWhatIf,
      disableReRunRanking
    } = this.state

    const {
      rankings,
      availablerankings,
      seasonweeks,
      rankingRunStarted,
      rankingPublicationStarted
    } = this.props

    const runningIcon = runningRanking && !rankingRunStarted ? "fa fa-spinner fa-spin" : "fa fa-bolt"
    
    this.setDefaultSeasonWeeks()

    return (<ContentWrapper>
      <div className="content-heading">Team Rankings</div>

      <Row>
        <Col xs={12}>
          {!showWhatIf && (<div className="stacked-filter-panel">
            <FormGroup controlId="role" className="city-filter">
              <ControlLabel>Season:</ControlLabel>
              <InputGroup>
                <FormControl componentClass="select" style={{ minWidth: '120px' }} onChange={this.handleSeasonChange}>
                  {!isEmpty(availablerankings) && this.generateSeasonOptions()}
                </FormControl>
                <FormControl componentClass="select" style={{ minWidth: '300px' }} onChange={this.handleWeekChange}>
                  {!isEmpty(seasonweeks) && this.generateSeasonWeeksOptions()}
                </FormControl>
                <FormControl componentClass="select" style={{ maxWidth: '120px' }} onChange={this.handleGenderChange}>
                  <option value="M">Men</option>
                  <option value="W">Women</option>
                </FormControl>
                <InputGroup.Button>
                  <Button onClick={this.handleShowRankings} style={{ color: blue }} >
                    <i className="fa fa-trophy" aria-hidden="true" />&nbsp;&nbsp;Show Rankings
                  </Button>
                </InputGroup.Button>
                <InputGroup.Button>
                  <Button onClick={this.handleReRunRankings} disabled={disableReRunRanking} style={{ color: red }}>
                    <i className={runningIcon} aria-hidden="true" />&nbsp;&nbsp;Rerun Rankings
                  </Button>
                </InputGroup.Button>
                <InputGroup.Button>
                  <Button onClick={this.handleRunWhatIf} style={{ color: warning }}>
                    <i className="fa fa-question" aria-hidden="true" />&nbsp;&nbsp;What If
                  </Button>
                </InputGroup.Button>
              </InputGroup>
            </FormGroup>

            {/*<Button onClick={this.handlePublishRankings}>*/}
            {/*  <i aria-hidden="true" />&nbsp;&nbsp;Publish Rankings*/}
            {/*</Button>*/}

          </div>)
          }
        </Col>
      </Row>
       {
        rankingPublicationStarted && 
        ( 
          <div sm={12}>
            <i className="fa fa-info-circle" style={{ color: blue }} aria-hidden="true" />&nbsp;&nbsp;
            Ranking publication has started. This may take several minutes to complete. Please check {"'"}Last Publish Details{"'"} for the outcome.
          </div>
        ) 
      } 
      {
        rankingRunStarted &&
        (
          <div sm={12}>
            <i className="fa fa-info-circle" style={{ color: blue }} aria-hidden="true" />&nbsp;&nbsp;
            The ranking process has been triggered. This may take several minutes (1-5 minutes) to complete. Please check {"'"}View Last Run Details{"'"} for the outcome.
          </div>
        )
      }
      {!rankingRunStarted && (!isEmpty(rankings)) && (rankings.length > 0) && (<Row>
        <Col xs={12}>
          <Table striped>
            <thead>
              <tr>
                <th>Rank</th>
                <th>Team</th>
                <th>Events</th>
                <th>Tier 1</th>
                <th>Avg</th>
                <th>AvgEF</th>
                <th>PP</th>
                <th>Total</th>
                <th>Previous</th>
                <th>+/- &nbsp; Change</th>
              </tr>
            </thead>
            <tbody>
              {rankings.map((item, key) => (
                <tr key={key}>
                  <td>{item.rankingNo}</td>
                  <td>{item.teamName}</td>
                  <td>{item.evt}</td>
                  <td>{item.tr1}</td>
                  <td>{item.avg}</td>
                  <td>{item.axEF}</td>
                  <td>{item.pPx2}</td>
                  <td>{item.total}</td>
                  <td>{item.prv}</td>
                  <td>{item.diff}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>)}
      {showWhatIf && (<WhatIf availablerankings={availablerankings} seasonweeks={seasonweeks} cancelShowWhatIf={this.onHandleCancelWhatIf} />)}

    </ContentWrapper>)
  }
}
Ranking.propTypes = {
  dispatch: PropTypes.func,
  norecordsfound: PropTypes.bool,
  fetchSeasonRankings: PropTypes.func,
  fetchAvailableRankings: PropTypes.func,
  fetchLastRankingRun: PropTypes.func,
  fetchSeasonWeeks: PropTypes.func,
  rankings: PropTypes.array,
  availablerankings: PropTypes.array,
  lastrankingrun: PropTypes.array,
  seasonweeks: PropTypes.array,
  seasonId: PropTypes.number,
  season: PropTypes.string,
  weekNumber: PropTypes.number,
  rankingRunStarted: PropTypes.bool,
  runRankings: PropTypes.func,
  rankingPublicationStarted: PropTypes.bool,
  publishRankings: PropTypes.func,
  oidc: PropTypes.object,
}
function mapStateToProps(state, ownProps) {
  const formName = ownProps.form
  const selector = formValueSelector(formName)
  const norecordsfound = selector(state, 'norecordsfound')
  const rankings = selector(state, 'rankings')
  const availablerankings = selector(state, 'availablerankings')
  const lastrankingrun = selector(state, 'lastrankingrun')
  const seasonweeks = selector(state, 'seasonweeks')
  const seasonId = selector(state, 'seasonId')
  const season = selector(state, 'season')
  const weekNumber = selector(state, 'weekNumber')
  const rankingRunStarted = selector(state, 'rankingRunStarted')
  const rankingPublicationStarted = selector(state, 'rankingPublicationStarted')
  return {
    norecordsfound,
    rankings,
    availablerankings,
    lastrankingrun,
    season,
    seasonweeks,
    seasonId,
    weekNumber,
    rankingRunStarted,
    rankingPublicationStarted,
    oidc: { ...state.oidc }
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchSeasonRankings,
    fetchAvailableRankings,
    fetchLastRankingRun,
    fetchSeasonWeeks,
    runRankings,
    publishRankings
  }, dispatch)
}
export default reduxForm({
  form: formName,
  destroyOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(Ranking))




// WEBPACK FOOTER //
// ./src/components/pages/Ranking/index.js